package com.milta.core.localization.translations.it

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Squadra",
    statusActive = "Attivo",
    errorGeneric = "Si è verificato un errore. Riprova.",
    monthNames = listOf("gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"),
    enterpriseSectionLabel = "Autisti del team",
    enterpriseEmptyHint = "Non ci sono ancora autisti nel tuo team.",
    noEnterpriseFound = "Nessuna azienda collegata al tuo account.",
    columnHeaderDriver = "Autista",
    columnHeaderStatus = "Stato",
    columnHeaderActions = "Azioni",
    addDriverSectionTitle = "Aggiungi un autista",
    addDriverCodePlaceholder = "Codice Milta — es. MTA-28371",
    addDriverButton = "Aggiungi questo autista",
    addDriverErrorInvalidCode = "Inserisci un codice valido.",
    addDriverErrorNotFound = "Codice non valido o già utilizzato.",
    addDriverErrorAlreadyMember = "Questo autista fa già parte del tuo team.",
    addDriverErrorLinkedAccountIsEnterprise = "Questo account è un'azienda e non può essere aggiunto come autista.",
    addDriverErrorLimitReached = "Limite raggiunto: un'azienda non può avere più di 10 membri, te compreso. Rimuovi un autista per aggiungerne un altro.",
    addDriverErrorEnterpriseSubscriptionInactive = "Il tuo abbonamento Azienda è scaduto: rinnovalo per aggiungere un autista.",
    driverDetailTitle = "Dettagli dell'autista",
    driverDetailPhoneLabel = "Telefono",
    removeDriverButton = "Rimuovi",
    removeDriverDialogTitle = "Rimuovere questo autista?",
    removeDriverDialogMessagePrefix = "Stai per rimuovere",
    removeDriverDialogMessageSuffix = "dal tuo team. Il suo account Milta rimarrà attivo.",
    removeDriverErrorNotFound = "Autista non trovato.",
    removeDriverErrorOnActiveDelivery = "Questo autista sta effettuando una consegna attiva e non può essere rimosso.",
    removeDriverErrorLastOwner = "Sei l'unico responsabile di questa azienda. Aggiungi un altro account Azienda prima di rimuoverti dal team.",
)
